const Text = ({ children }) => {
    return (
      <p>{children}</p>
    )
}

export { Text }
